import * as React from 'react';
import { Transition } from 'react-spring/renderprops.cjs';

import { Portal } from '../../components';
import { H3, P } from '../../typography';
import { StyledSystemProps } from '../../theme/StyledSystemProps';
import {
  ModalWrap,
  ModalInner,
  ModalBodyCont,
  ModalHeaderCont,
  CloseButton,
  ModalFooterCont,
  ModalChildrenBodyContent,
} from './Elements';

const MODAL_ANIM_CONFIG = {
  duration: 250,
  tension: 100,
  friction: 10,
};

type ModalProps = StyledSystemProps & {
  headerContent?: React.ReactNode;
  body?: string;
  open: boolean;
  heading?: string;
  actions?: React.ReactNode;
  onClick?: () => void;
  onClose: () => void;
};

const Modal: React.FC<ModalProps> = props => {
  function renderContent() {

    const { children, heading, body, onClose, actions, headerContent } = props;
    const hasAction = !!actions;
    if (children) {
      return (
        <React.Fragment>
          <ModalHeaderCont>
            <H3 fontWeight="lighter">{heading}</H3>
            {headerContent}
            <CloseButton onClick={onClose} />
          </ModalHeaderCont>
          <ModalChildrenBodyContent>
            {children}
          </ModalChildrenBodyContent>
        </React.Fragment>
      );
    }
    return (
      <React.Fragment>
        <ModalHeaderCont>
          <H3 fontWeight="lighter">{heading}</H3>
          {headerContent}
          <CloseButton onClick={onClose} />
        </ModalHeaderCont>
        <ModalBodyCont hasAction={!hasAction}>
          <P p={0} m={0}>
            {body}
          </P>
        </ModalBodyCont>
        {actions && <ModalFooterCont>{actions}</ModalFooterCont>}
      </React.Fragment>
    );
  }

  const { open } = props;
  return (
    <Transition
      items={open}
      native={true}
      config={MODAL_ANIM_CONFIG}
      from={{
        opacity: 0,
        transform: 'translateY(40px)',
      }}
      enter={{
        opacity: 1,
        transform: 'translateY(0)',
      }}
      leave={{
        opacity: 0,
        transform: 'translateY(40px)',
        pointerEvents: 'none',
      }}
    >
      {modalOpen =>
        modalOpen &&
        (styleProps => (
          <Portal>
            <ModalWrap style={{ opacity: styleProps.opacity }}>
              <ModalInner {...props} style={styleProps} heading="ASDASDASDASDSA">
                {renderContent()}
              </ModalInner>
            </ModalWrap>
          </Portal>
        ))
      }
    </Transition>
  );
};

export default Modal;

Modal.defaultProps = {
  heading: 'Modal Heading',
  body: 'Modal Body',
  onClose: () => null,
  bg: 'white',
  py: 4,
  px: 1,
};



// WEBPACK FOOTER //
// ./src/components/modal/Modal.tsx